window.addEventListener('DOMContentLoaded', function() {

  const banner = document.querySelector('#collection-hero-banner');
  const shopNowButton = banner.querySelector('.tab-buttons .button.shop');
  const exploreButton = banner.querySelector('.tab-buttons .button.explore');
  // const exploreSectionsCount = banner.dataset.exploreSectionsCount;
  let exploreSections = [];

  // get all explore sections
  Array.from(banner.parentElement.parentElement.children).forEach((child, index) => {
    const isPartofPCPExploreCollection = child.querySelector('.part-of-pcp-explore-tab')
    if (isPartofPCPExploreCollection) {
      exploreSections.push(child)
    }
  })

  // create wrapper for all explore sections
  const exploreSectionsWrapper = document.createElement('div');
  exploreSectionsWrapper.classList.add('explore-sections-wrapper');
  exploreSectionsWrapper.id = 'explore-sections-wrapper';
  exploreSectionsWrapper.setAttribute('aria-hidden', 'true');

  // create inner wrapper for all explore sections
  const exploreSectionsInnerWrapper = document.createElement('div');
  exploreSectionsInnerWrapper.classList.add('explore-sections-inner-wrapper');

  // append all explore sections to inner wrapper
  exploreSections.forEach(section => {
    exploreSectionsInnerWrapper.appendChild(section);
  });

  // append inner wrapper to wrapper
  exploreSectionsWrapper.appendChild(exploreSectionsInnerWrapper);

  // insert wrapper after banner
  banner.parentElement.insertAdjacentElement('afterend', exploreSectionsWrapper);

  // remove hidden class from all explore sections
  exploreSections.forEach(section => {
    const el = section.querySelector('.part-of-pcp-explore-tab')
    el.classList.remove('hidden');
  });

  if(exploreButton && shopNowButton) {
    exploreButton.addEventListener('click', function() {
      shopNowButton.classList.remove('is-active');
      exploreButton.classList.add('is-active');
      exploreSectionsWrapper.setAttribute('aria-hidden', 'false');
      exploreButton.setAttribute('aria-expanded', 'true');
    });

    shopNowButton.addEventListener('click', function() {
      exploreButton.classList.remove('is-active');
      shopNowButton.classList.add('is-active');
      exploreSectionsWrapper.setAttribute('aria-hidden', 'true');
      exploreButton.setAttribute('aria-expanded', 'false');
    });
  }

  // check url params for 'explore-tab' and open explore tab
  const urlParams = new URLSearchParams(window.location.search);
  const exploreTab = urlParams.get('explore-tab');
  if(exploreTab) {
    exploreButton.click();
  }

});